import { forwardRef, AnchorHTMLAttributes } from 'react';

export const Clickable = forwardRef<HTMLAnchorElement, AnchorHTMLAttributes<HTMLAnchorElement>>(function Clickable(props, ref) {
  const { href: _href, children, ...rest } = props;
  return (
    <a ref={ref} role="button" tabIndex={0} {...rest}>
      {children}
    </a>
  );
});
